import { useMediaQuery } from '@react-hookz/web';
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';

import pillCrossed from 'public/pill-crossed.svg';
import pillTall from 'public/pill-tall2.svg';
import pillTriangle from 'public/pill-triangle.svg';
import { UNIFIED } from 'src/app/analytics/analyticsEvents';
import CopyrightFooter from 'src/app/components/Elements/CopyrightFooter';
import { Section } from 'src/app/components/Elements/Section';
import { Typography } from 'src/app/components/Elements/Typography';
import { segmentTrack } from 'src/app/state/actions';

import { Accordion, PillCrossed, PillTall, PillTriangle, TextContainer } from '../styles';

const FAQSection = ({ expandCallback, header, questionContent, expandFirstQuestion, bodyClassName, id }) => {
  const smDown = useMediaQuery('(max-width: 575px)');
  const mdDown = useMediaQuery('(max-width: 767px)');

  return (
    <Section id={id}>
      <PillTriangle src={pillTriangle} />
      <PillCrossed src={pillCrossed} />
      <PillTall src={pillTall} />
      <Row>
        <Col xs="12">
          <TextContainer>
            <Typography variant={mdDown ? 'h1' : 'displayXXL'}>{header}</Typography>
          </TextContainer>
        </Col>
      </Row>
      <Row>
        <Accordion
          questions={questionContent}
          hideLines
          bodyTextClassName="normal"
          expandCallback={expandCallback}
          expandFirstQuestion={expandFirstQuestion}
          bodyClassName={bodyClassName}
        />
      </Row>
      <Row>
        <CopyrightFooter marginBottom={smDown ? 's9' : 's7'} textColor={'gray'} />
      </Row>
    </Section>
  );
};

const ConnectedFAQSection = connect(null, dispatch => ({
  expandCallback: (questions: { question: string }[], expandedIndex: [number]) => {
    // Expanded indexes will return an empty array when all accordions are collapsed
    if (expandedIndex?.length) {
      const text = questions[expandedIndex[0]].question;
      dispatch(segmentTrack(UNIFIED.expandOTCFaq, { text }));
    }
  },
}))(FAQSection);

export { ConnectedFAQSection as FAQSection };
